import React, { useState, useEffect, useContext } from "react";
import jMoment from "moment-jalaali";
import Input from "../../shared/components/Input";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_DATE,
  VALIDATOR_SELECT,
} from "../../shared/util/validators";
import axios from "axios";
import useForm from "../../shared/hooks/form-hooks";
import { AuthContext } from "../../context/AuthContext";
import { useSnackbar } from "notistack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import { CircularProgress } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { baseUrl } from "../../baseUrl";
import SortingReceipts from "../../receipts/components/SortingReceipts";

const DoneSearchReceipts = (props) => {
  const [direction, setDirection] = useState({ name: "نزولی", value: "DESC" });
  const [sortBy, setSortBy] = useState({
    name: "تاریخ شروع",
    value: "startDate",
  });

  const [status, setStatus] = useState({ name: "مختومه", value: 2 });

  const sortUpdater = (name, dir, st) => {
    setSortBy(name);
    setDirection(dir);
    setStatus(st);
  };

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const auth = useContext(AuthContext);
  const [formState, inputHandler] = useForm(
    {
      patientName: {
        value: "",
        isValid: true,
      },
      doctorName: {
        value: "",
        isValid: true,
      },
      boxNumber: {
        value: "",
        isValid: true,
      },
      orderType: {
        value: "",
        isValid: true,
      },
      startDate1: {
        value: "",
        isvalid: true,
      },
      startDate2: {
        value: "",
        isvalid: true,
      },
      endDate1: {
        value: "",
        isvalid: true,
      },
      endDate2: {
        value: "",
        isvalid: true,
      },
    },
    true
  );
  const receiptsSearchCaseHandlerSearchHandler = (event) => {
    event.preventDefault();
    setUpdater(!updater);
  };
  // get doctors name
  const [doctorNames, setDoctorNames] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    async function sendRequest() {
      setIsLoading(true);
      try {
        const response = await fetch(
          baseUrl + `/api/v1/laboratorys/get-doctors`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: auth.token,
            },
            body: JSON.stringify({
              onlyName: true,
              page: 1,
            }),
          }
        );
        if (response.ok) {
          const responseData = await response.json();
          setDoctorNames(responseData.data.result);
        } else {
          throw new Error(response.message);
        }
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        err &&
          err.data.map((error) => {
            enqueueSnackbar(error, { variant: "error" });
          });
      }
    }

    sendRequest();
  }, []);

  // get orders list
  const [orderTypes, setOrderTypes] = useState([]);
  useEffect(() => {
    async function sendRequest() {
      setIsLoading(true);
      try {
        const response = await fetch(
          baseUrl + `/api/v1/laboratorys/get-orderTypes`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: auth.token,
            },
            body: JSON.stringify({
              onlyName: true,
              page: 0,
              rowCount: 0,
            }),
          }
        );
        if (response.ok) {
          const responseData = await response.json();
          setOrderTypes(
            responseData.data.result.map((item) => {
              return { label: item.name, id: item.id };
            })
          );
        } else {
          throw new Error(response.message);
        }
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        err &&
          err.data.map((error) => {
            enqueueSnackbar(error, { variant: "error" });
          });
      }
    }

    sendRequest();
  }, []);

  //order search handler
  const [total, setTotal] = useState();
  const [updater, setUpdater] = useState(true);
  const [receiptsSearchCaseHandler, setReceiptsSearchCaseHandler] = useState(
    []
  );
  async function sendRequest() {
    setIsLoading(true);
    axios
      .post(
        "/api/v1/laboratorys/search-orders",
        {
          ...(formState.inputs.patientName.value && {
            patiantName: formState.inputs.patientName.value,
          }),
          ...(formState.inputs.doctorName.value.name && {
            doctorName: formState.inputs.doctorName.value.name,
          }),
          ...(formState.inputs.boxNumber.value && {
            boxNumber: formState.inputs.boxNumber.value,
          }),
          ...(formState.inputs.orderType.value.id && {
            orderTypeId: formState.inputs.orderType.value.id,
          }),
          ...(formState.inputs.startDate1.value && {
            startDateStart: new Date(
              formState.inputs.startDate1.value
            ).getTime(),
          }),
          ...(formState.inputs.startDate2.value && {
            startDateEnd: new Date(formState.inputs.startDate2.value).getTime(),
          }),
          ...(formState.inputs.endDate1.value && {
            endDateInterval1: new Date(
              formState.inputs.endDate1.value
            ).getTime(),
          }),
          ...(formState.inputs.endDate2.value && {
            endDateInterval2: new Date(
              formState.inputs.endDate2.value
            ).getTime(),
          }),
          ascending: direction.value,
          sort: sortBy.value,
          page: props.page,
          status: status.value,
          rowCount: 15,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        setIsLoading(false);
        setReceiptsSearchCaseHandler([]);
        response.data.data.result.map((order) => {
          const unitPriceCalc = () => {
            if (order.unitCount === "فک یالا") {
              return order.orderType.jawPrice;
            } else if (order.unitCount === "فک پایین") {
              return order.orderType.twoJawPrice;
            } else {
              return order.orderType.perUnitPrice;
            }
          };
          const totalPriceCalc = () => {
            if (order.unitCount === "فک یالا") {
              return order.orderType.jawPrice;
            } else if (order.unitCount === "فک پایین") {
              return order.orderType.twoJawPrice;
            } else {
              return order.orderType.perUnitPrice * order.unitCount;
            }
          };
          setReceiptsSearchCaseHandler((prevState) => [
            ...prevState,
            {
              id: order.id,
              boxNumber: order.boxNumber,
              patientName: order.patiantName,
              doctorName: order.doctorLab.name,
              startDate: order.startDate,
              orderType: order.orderType.name,
              endDate: order.process?.endDate,
              unitCount: order.unitCount,
              orderTypeId: order.orderTypeId,
              unitPrice: unitPriceCalc(),
              totalPrice: totalPriceCalc(),
            },
          ]);
        });
        setTotal(response.data.data.totalItem);
      })
      .catch((e) => {
        const messages = e.response.data.data;
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
        setIsLoading(false);
      });
  }
  //getting pageCount from total orders
  const pageCount = Math.ceil(total / 15);

  //receiptsSearchCaseHandler search request
  useEffect(() => {
    // orderTypesDetails &&
    sendRequest();
  }, [updater, props.page]);

  // sending the data to the parent component
  useEffect(() => {
    props.getReceiptData(receiptsSearchCaseHandler, pageCount);
  }, [receiptsSearchCaseHandler]);

  // 	sendRequest();
  // }, []);

  //test
  // useEffect(() => {
  // 	console.log(orderTypesDetails)
  // }, [orderTypesDetails]);

  return (
    <React.Fragment>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Paper>
        <form onSubmit={receiptsSearchCaseHandlerSearchHandler}>
          <Grid container spacing={2}>
            <SortingReceipts sortUpdater={sortUpdater} />
            <Grid md={3} xs={6}>
              <Input
                id="patientName"
                element="input"
                label="نام بیمار"
                validators={[VALIDATOR_VALIDATED()]}
                errorText="لطفا نام بیمار را وارد کنید."
                onInput={inputHandler}
                inputValid={true}
                size="small"
                variant="standard"
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="doctorName"
                element="autoComplete"
                label="نام پزشک"
                validators={[VALIDATOR_AUTOCOMPLETE()]}
                errorText="لطفا نام دکتر را انتخاب کنید."
                onInput={inputHandler}
                options={doctorNames}
                getOptionLabel={(option) => option.name}
                inputValid={true}
                size="small"
                variant="standard"
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="boxNumber"
                element="input"
                label="شماره جعبه"
                validators={[VALIDATOR_VALIDATED()]}
                errorText="لطفا شماره جعبه را وارد نمایید."
                onInput={inputHandler}
                inputValid={true}
                size="small"
                variant="standard"
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="orderType"
                element="autoComplete"
                label="نوع کار"
                validators={[VALIDATOR_AUTOCOMPLETE()]}
                errorText="لطفا نوع کار را انتخاب کنید."
                onInput={inputHandler}
                options={orderTypes}
                getOptionLabel={(order) => order.label}
                required={true}
                inputValid={true}
                size="small"
                variant="standard"
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Grid md={12}>
                <Typography
                  variant="caption"
                  display="block"
                  gutterBottom
                  sx={{ mb: -1 }}
                >
                  بازه شروع سفارش
                </Typography>
              </Grid>
              <Grid md={12}>
                <Input
                  id="startDate1"
                  element="datePick"
                  validators={[VALIDATOR_VALIDATED()]}
                  errorText="ورودی نامعتبر"
                  onInput={inputHandler}
                  inputValid={true}
                  disabled={false}
                  label="شروع"
                  disableFuture={true}
                  size="small"
                  variant="standard"
                />
              </Grid>
              <Grid md={12}>
                <Input
                  id="startDate2"
                  element="datePick"
                  validators={[VALIDATOR_VALIDATED()]}
                  errorText="ورودی نامعتبر"
                  onInput={inputHandler}
                  inputValid={true}
                  disabled={false}
                  label="پایان"
                  disableFuture={true}
                  size="small"
                  variant="standard"
                />
              </Grid>
            </Grid>
            <Grid md={6} xs={12}>
              <Grid md={12}>
                <Typography
                  variant="caption"
                  display="block"
                  gutterBottom
                  sx={{ mb: -1 }}
                >
                  بازه تحویل سفارش
                </Typography>
              </Grid>
              <Grid md={12}>
                {" "}
                <Input
                  id="endDate1"
                  element="datePick"
                  validators={[VALIDATOR_VALIDATED()]}
                  errorText="ورودی نامعتبر"
                  onInput={inputHandler}
                  inputValid={true}
                  disabled={false}
                  label="شروع"
                  disableFuture={true}
                  size="small"
                  variant="standard"
                />
              </Grid>
              <Grid md={12}>
                <Input
                  id="endDate2"
                  element="datePick"
                  validators={[VALIDATOR_VALIDATED()]}
                  errorText="ورودی نامعتبر"
                  onInput={inputHandler}
                  inputValid={true}
                  disabled={false}
                  label="پایان"
                  disableFuture={true}
                  size="small"
                  variant="standard"
                />
              </Grid>
            </Grid>
            <Grid xs={12} sm={12}>
              <Button
                type="submit"
                disabled={!formState.isValid}
                fullWidth
                color="secondary"
                variant="outlined"
                size="small"
              >
                جستجو
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </React.Fragment>
  );
};

export default DoneSearchReceipts;
